import { render, staticRenderFns } from "./mainFilter.vue?vue&type=template&id=3a8f51b6&scoped=true&"
import script from "./mainFilter.vue?vue&type=script&lang=js&"
export * from "./mainFilter.vue?vue&type=script&lang=js&"
import style0 from "./mainFilter.vue?vue&type=style&index=0&id=3a8f51b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f51b6",
  null
  
)

export default component.exports